<template>
    <v-container fluid>
        <v-row no-gutters @click="clicked">
            <v-col cols="4">
                {{label}}
            </v-col>
            <v-col cols="8">
                {{value}}
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

    import {clipboardMixin} from "../mixins/clipboardMixin";

    export default {

        mixins: [clipboardMixin],

        components: {},

        props: {
            label: {
                required: true,
                type: String,
            },

            value: {
                required: true,
                type: String | Number,
            }
        },

        methods: {
            clicked() {
                this.copyToClipboard(this.value);
                Bus.$emit('flash-message', {message: 'Copied to the clipboard'});
            }
        }
    }
</script>
